import React, { lazy } from 'react';
import GuestGuard from '../guards/authGuard/GuestGaurd';
import Loadable from '../layouts/full/shared/loadable/Loadable';
import AuthGuard from '../guards/authGuard/AuthGuard';
import { Navigate } from 'react-router-dom';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ***Pages*** */
const DashboardCards = Loadable(lazy(() => import('../views/dashboard/Main')));
const Receipts = Loadable(lazy(() => import('../views/employee-portal/receipts')));
const Applications = Loadable(lazy(() => import('../views/employee-portal/application-list')));
const ApplicationDetails = Loadable(
  lazy(() => import('../views/application-details/ApplicationsDetails')),
);
const BuyGiftCard = Loadable(lazy(() => import('../views/employee-portal/buy-gift-card')));
const YourGiftCards = Loadable(lazy(() => import('../views/employee-portal/your-gift-cards')));

/* ***Settings*** */
const EmployeeSettings = Loadable(
  lazy(() => import('../views/employee-portal/settings-page/index'))
);

/* ***Authentication**** */
const ViewWrapper = Loadable(lazy(() => import('./wrapper/ViewWrapper')));
const Login = Loadable(lazy(() => import('../views/authentication/auth1/Login')));
const EmployerSetPassword = Loadable(
  lazy(() => import('../views/authentication/auth1/EmployerSetPassword')),
);
const ForgotPassword = Loadable(lazy(() => import('../views/authentication/auth1/ForgotPassword')));
const SetupNewPassword = Loadable(
  lazy(() => import('../views/authentication/auth1/SetupNewPassword')),
);
const Error = Loadable(lazy(() => import('../views/authentication/Error')));

export const baseEmployeeURL = process.env.REACT_APP_EMPLOYEE_PORTAL_ROUTE as string;

export const employeeRoutes = [
  {
    path: `${baseEmployeeURL}`,
    element: (
      <AuthGuard>
        <FullLayout />
      </AuthGuard>
    ),
    children: [
      { path: `${baseEmployeeURL}`, element: <Navigate to={`${baseEmployeeURL}/dashboard`} /> },
      {
        path: `${baseEmployeeURL}/dashboard`,
        exact: true,
        element: (
          <ViewWrapper title="Dashboard" description="Dashboard page">
            <DashboardCards />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseEmployeeURL}/applications`,
        exact: true,
        element: (
          <ViewWrapper title="Applications">
            <Applications />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseEmployeeURL}/application/view-details/:id`,
        exact: true,
        element: (
          <ViewWrapper title={'Application'}>
            <ApplicationDetails />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseEmployeeURL}/application/view-details/:id`,
        exact: true,
        element: (
          <ViewWrapper title={'Application'}>
            <ApplicationDetails />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseEmployeeURL}/receipts`,
        exact: true,
        element: (
          <ViewWrapper title={'Receipts'}>
            <Receipts />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseEmployeeURL}/buy-gift-card`,
        exact: true,
        element: (
          <ViewWrapper title="Buy Gift Card" description="Buy Gift Card page">
            <BuyGiftCard />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseEmployeeURL}/your-gift-cards`,
        exact: true,
        element: (
          <ViewWrapper title="Your Gift Cards" description="Your Gift Cards page">
            <YourGiftCards />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseEmployeeURL}/account/settings`,
        exact: true,
        element: (
          <ViewWrapper title={'Settings'}>
            <EmployeeSettings />
          </ViewWrapper>
        ),
      },
      { path: `${baseEmployeeURL}/404`, exact: true, element: <Error /> },
      { path: '*', exact: true, element: <Navigate to={`/404`} /> },
    ],
  },
  {
    path: '/',
    element: (
      <GuestGuard>
        <BlankLayout />
      </GuestGuard>
    ),
    children: [
      { path: `${baseEmployeeURL}/auth/404`, element: <Error /> },
      {
        path: `${baseEmployeeURL}/auth/login`,
        element: (
          <ViewWrapper title="Login">
            <Login title={'Login'}/>
          </ViewWrapper>
        ),
      },
      {
        path: `${baseEmployeeURL}/auth/set-password`,
        element: (
          <ViewWrapper title="Login" description="Login page">
            <EmployerSetPassword />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseEmployeeURL}/auth/forgot-password`,
        element: (
          <ViewWrapper title="Forgot Password" description="Forgot Password page">
            <ForgotPassword />
          </ViewWrapper>
        ),
      },
      {
        path: `${baseEmployeeURL}/auth/new-password-setup`,
        element: (
          <ViewWrapper title="New Password Setup" description="New Password Setup page">
            <SetupNewPassword />
          </ViewWrapper>
        ),
      },
    ],
  },
];
